import { css } from 'styled-components';
import _ from 'lodash';
import { fontVariables, mediaTemplates } from 'theme/variables';

const mediaQueries = css`
  ${(props) =>
    props.size !== 'fs_xxs' &&
    props.size !== 'fs_xs' &&
    props.size !== 'fs_s' &&
    props.size !== 'fs_md' &&
    !props.fixedSize &&
    css`
      @media screen and (${mediaTemplates.lWidth}) {
        font-size: ${_.get(fontVariables, props.size, null) ||
        fontVariables.fs_s};
      }
    `}

  ${(props) =>
    props.size === 'fs_xs' &&
    !props.fixedSize &&
    css`
      @media screen and (${mediaTemplates.lWidth}) {
        font-size: ${fontVariables.fs_s};
      }
    `}

  ${(props) =>
    props.size === 'fs_xxs' &&
    !props.fixedSize &&
    css`
      @media screen and (${mediaTemplates.lWidth}) {
        font-size: ${fontVariables.fs_s};
      }
    `}

  ${(props) =>
    props.size === 'fs_s' &&
    !props.fixedSize &&
    css`
      line-height: 20px;

      @media screen and (${mediaTemplates.lWidth}) {
        line-height: 25px;
        font-size: ${fontVariables.fs_md};
      }
    `}

  ${(props) =>
    props.size === 'fs_md' &&
    !props.fixedSize &&
    css`
      line-height: 20px;

      @media screen and (${mediaTemplates.lWidth}) {
        line-height: 25px;
        font-size: ${fontVariables.fs_xl};
      }
    `}
`;

export default mediaQueries;
